export const GET_LIST_SUCCESS = '@@orders/GET_LIST_SUCCESS';

export const GET_ORDERS_LIST_SUCCESS = '@@orders/GET_ORDERS_LIST_SUCCESS';

export const GET_PAGINATION_SUCCESS = '@@orders/GET_PAGINATION_SUCCESS';

export const GET_CONFIG_SUCCESS = '@@orders/GET_CONFIG_SUCCESS';

export const CHANGE_STATUS = '@@orders/CHANGE_STATUS';

export const GET_EXPORT_CONFIG = '@@orders/GET_EXPORT_CONFIG';
export const GET_EXPORT_CONFIG_SUCCESS = '@@orders/GET_EXPORT_CONFIG_SUCCESS';
export const GET_EXPORT_CONFIG_ERROR = '@@orders/GET_EXPORT_CONFIG_ERROR';

export const GET_EXPORT_LIST = '@@orders/GET_EXPORT_LIST';
export const GET_EXPORT_LIST_SUCCESS = '@@orders/GET_EXPORT_LIST_SUCCESS';
export const GET_EXPORT_LIST_ERROR = '@@orders/GET_EXPORT_LIST_ERROR';

export const MAKE_EXPORT = '@@orders/MAKE_EXPORT';
export const MAKE_EXPORT_SUCCESS = '@@orders/MAKE_EXPORT_SUCCESS';
export const MAKE_EXPORT_ERROR = '@@orders/MAKE_EXPORT_ERROR';

export const GET_USERS_LIST_SEARCH = '@@orders/GET_USERS_LIST_SEARCH';
export const GET_USERS_LIST_SEARCH_SUCCESS = '@@orders/GET_USERS_LIST_SEARCH_SUCCESS';
export const GET_USERS_LIST_SEARCH_ERROR = '@@orders/GET_USERS_LIST_SEARCH_ERROR';

export const DELETE_HINT = '@@orders/DELETE_HINT';

export const GET_STATUSES_COUNTS_SUCCESS = '@@orders/GET_STATUSES_COUNTS_SUCCESS';

export const FETCHING = '@@orders/FETCHING';
export const FETCHING_PAGINATION = '@@orders/FETCHING_PAGINATION';

export const ERROR = '@@orders/ERROR';
export const ERROR_INIT = '@@orders/ERROR_INIT';

export const UPDATE_LIST = '@@orders/UPDATE_LIST';
export const UPDATE_LIST_SUCCESS = '@@orders/UPDATE_LIST_SUCCESS';
